export enum FindAccountantActionPoint {
  GetAFreeQuote = 1,
  InviteYourAccountant = 2,
}
